import { render, staticRenderFns } from "./poromotion.vue?vue&type=template&id=feab831e&scoped=true"
import script from "./poromotion.vue?vue&type=script&lang=js"
export * from "./poromotion.vue?vue&type=script&lang=js"
import style0 from "./poromotion.vue?vue&type=style&index=0&id=feab831e&prod&lang=scss&scoped=true"
import style1 from "./poromotion.vue?vue&type=style&index=1&id=feab831e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feab831e",
  null
  
)

export default component.exports